var _defs, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}.b{fill:#fff;font-size:8px;font-family:OpenSans-Bold, Open Sans;font-weight:700;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 12,
    rx: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(2 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.2f3ce064312e260e02b4a28873dba578.svg";
export { ForwardRef as ReactComponent };